export default {"src":"/_next/static/image/public/images/ic_uaepass_logo.5bedbeb8a0aa43c2df6343996cb6ae15.svg","height":27,"width":28};